export function escapeCsv (value) {
  if (value === null || value === undefined) return ''
  const str = String(value)
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

export function capitalize (value) {
  if (!value) {
    return ''
  }
  return value.toString().charAt(0).toUpperCase() + value.slice(1)
}
